import { Search as SearchIcon } from 'lucide-react';

function SuggestionSearchForm(props) {
    function handleSubmitACB(event) {
        event.preventDefault();
        props.doSearch();
    }
    function handleInputACB(event) {
        props.setSearchParams({
            keyword: event.target.value
        });
    }
    return (
        <div>
           <div className="relative mb-4">
            <form onSubmit={handleSubmitACB}>
                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-amber-400" />
                <input
                    type="text"
                    onChange={handleInputACB}
                    placeholder="Search by book title or author..."
                    className="w-full pl-10 pr-4 py-3 !border border-amber-200 !rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                />
            </form>
          </div>
        </div>
    );
}
export default SuggestionSearchForm;


